import {
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownSeparator,
  DropdownTrigger,
} from '@/components/atoms/dropdown';
import { HttpService } from '@/features/api/http.service';
import { useMixpanel } from '@/hooks/useMixpanel';
import { BUTTON_CLICKED } from '@/libs/mixpanel';
import type { ISession } from '@/types/auth';

export const UserMenu: React.FC<{ user: ISession }> = ({ user }) => {
  const { email, name, picture } = user;
  const trackButtonClicked = useMixpanel((state) => state.trackButtonClicked);

  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <button
          className="flex items-center justify-center size-8 rounded-md overflow-hidden bg-gray-200"
          type="button"
        >
          {picture ? (
            <img src={picture} alt={name || email} className="size-full object-cover" />
          ) : (
            <span className="text-sm font-medium text-gray-600">{name?.[0] || email[0]}</span>
          )}
        </button>
      </DropdownTrigger>
      <DropdownContent align="end" className="w-56 z-[60]">
        <DropdownItem className="flex flex-col items-start px-4 py-2">
          <span className="font-bold">{name || 'User'}</span>
          <span className="text-sm text-muted-foreground">{email}</span>
        </DropdownItem>
        <DropdownSeparator />
        <DropdownItem
          onClick={() => {
            trackButtonClicked(BUTTON_CLICKED.SIGN_OUT);
            HttpService.deleteSessionMe();
          }}
        >
          Sign out
        </DropdownItem>
      </DropdownContent>
    </Dropdown>
  );
};
